import tw, { css, styled } from 'twin.macro';
import Icon from '@/components/Icon/IconSprite';

const sharedCSSPreviousNext = css`
  ${tw`absolute`}
  ${tw`top-0`}
  ${tw`h-full`}
  ${tw`w-[52px] md:w-[160px]`}
  ${tw`z-[1]`}
  ${tw`flex items-center justify-center`}
  ${tw`pointer-events-none cursor-pointer`}
  // NOTE: This is a pseudo-element used to hide the carousel overflow on the left and right sides of the screen.
  // WHY? part 1: The carousel is full screen width and its overflow is visible in order to let gradients bleed out of the container size.
  // WHY? part 2: The overflow of the carousel still needs to be hidden to not let the carousel content be visible outside of the container.
  ${tw`after:[content: ''] after:absolute`}
  ${tw`after:bg-ui-colours-ui1`}
  ${tw`after:w-[calc(((100vw - 100%) / 2))]`}
  ${tw`after:h-full`}
`;

export const CarouselPrevious = styled.div`
  ${sharedCSSPreviousNext}
  ${tw`left-0 md:left-[-80px]`}
  ${tw`pr-1 md:pr-4`}
  ${tw`after:-left-[calc(((100vw - 100%) / 2))]`}
  &:not(.swiper-button-disabled) {
    ${tw`bg-gradient-to-r from-ui-colours-ui1 from-60% to-100%`}
  }
`;

export const CarouselNext = styled.div`
  ${sharedCSSPreviousNext}
  ${tw`right-0 md:right-[-80px]`}
  ${tw`pl-1 md:pl-4`}
  ${tw`after:-right-[calc(((100vw - 100%) / 2))]`}
  &:not(.swiper-button-disabled) {
    ${tw`bg-gradient-to-l from-ui-colours-ui1 from-60% to-100%`}
  }
`;

export const Chevron = styled(Icon)`
  ${tw`text-secondary-s1 hover:text-ui-colours-ui2`}
  ${tw`h-[32px]`}
  ${tw`pointer-events-auto`}
  &.swiper-button-disabled {
    ${tw`hidden`}
  }
`;
